import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ReloadStateService } from '@app/shared/services/reload-state.service';
import { SessionStorageService } from '@core/services/session-storage.service';

// Use a variable to track if reload check was done in this session
let reloadCheckDone = false;

export const reloadGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const sessionStorage = inject(SessionStorageService);
  const reloadState = inject(ReloadStateService);

  const reloadCheckDone = reloadState.getReloadChecked();

  // If reload check already done, skip
  if (!reloadCheckDone) {
    sessionStorage.clear();
    router.navigate(['/eclaim']);
  }

  return true;
};
